import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom-v5-compat';
import { Field, InjectedFormProps, reduxForm } from 'redux-form';
import { FONT_SIZES, SPACINGS } from 'shared/styles/variables';
import styled from 'styled-components';

import InputField from 'dashboard/components/FormControls/InputField';
import TextAreaField from 'dashboard/components/FormControls/TextAreaField';
import ThemeEditorFormActionFooter, {
  ACTION_FOOTER_HEIGHT,
} from 'dashboard/components/ThemeEditorFormActionFooter';
import { FORM_THEME_EDITOR_SELECT_COUNTRY_PAGE_NAME } from 'dashboard/lib/constants/formNames';
import { COLORS } from 'dashboard/styles/variables';

const Title = styled('h2')`
  color: ${COLORS.black};
  padding-top: ${SPACINGS.base * 5}px;
  padding-left: ${SPACINGS.base * 2}px;
`;
const Subtitle = styled('p')`
  display: inline-block;
  border-bottom: 1px solid ${COLORS.gray20};
  padding-bottom: ${SPACINGS.base * 3}px;
  padding-left: ${SPACINGS.base * 2}px;
  padding-right: ${SPACINGS.base * 2}px;
`;
const Section = styled('div')`
  padding: ${SPACINGS.base * 2}px;
  margin-bottom: ${ACTION_FOOTER_HEIGHT};
`;
const StyledLabel = styled('label')`
  display: inline-block;
`;
const Hint = styled('p')`
  font-size: ${FONT_SIZES.small};
  color: ${COLORS.gray50};
  margin-bottom: ${SPACINGS.base}px;
`;
const StyledField = styled(Field)<any>`
  margin-bottom: ${SPACINGS.base * 3}px;
`;

const FormThemeEditorSelectCountryPage = (props: InjectedFormProps) => {
  const [t] = useTranslation();
  return (
    <form onSubmit={props.handleSubmit}>
      <Title>Select Country Page</Title>
      <Subtitle>
        Custom text in the flow will not be translated unless custom translation file(s) are added.
        <Link to='/dashboard/contact-us'>Contact us</Link> to add your custom file(s).
      </Subtitle>
      <Section>
        <StyledLabel htmlFor='select-country-theme-form__title-input'>Title</StyledLabel>
        <Hint>Title for country select page</Hint>
        <StyledField
          type='text'
          id='select-country-theme-form__title-input'
          placeholder={t('select-country.title')}
          name='template.select-country-title'
          component={InputField}
        />

        <StyledLabel htmlFor='select-country-theme-form__body-input'>Body</StyledLabel>
        <Hint>Body for country select page</Hint>
        <StyledField
          id='select-country-theme-form__body-input'
          name='template.select-country-prompt'
          placeholder={t('select-country.prompt')}
          component={TextAreaField}
        />
      </Section>

      <ThemeEditorFormActionFooter
        dataTestBlock='form-theme-editor-select-country-page'
        handleUndo={props.reset}
        submitting={props.submitting}
        pristine={props.pristine}
      />
    </form>
  );
};

export default reduxForm<{}>({
  form: FORM_THEME_EDITOR_SELECT_COUNTRY_PAGE_NAME,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
})(FormThemeEditorSelectCountryPage);
